const StateMachineErrorCodes = {
  STM0001: 'Item está em um estado que não permite essa ação.'
} as const;

export default StateMachineErrorCodes;
